var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveplanicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_995_32388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.61548 1.66602H3.03084C2.66835 1.66602 2.3207 1.81001 2.06438 2.06633C1.80806 2.32266 1.66406 2.6703 1.66406 3.03279V8.61653C1.66398 8.79604 1.69927 8.97382 1.7679 9.1397C1.83653 9.30558 1.93717 9.45631 2.06407 9.58329L10.4114 17.9325C10.5731 18.0941 10.7728 18.2127 10.9922 18.2772C11.2116 18.3417 11.4437 18.3501 11.6672 18.3017C11.8906 18.2533 12.0984 18.1496 12.2714 18.0001C12.4444 17.8505 12.5772 17.66 12.6575 17.4459L13.965 13.967L17.4449 12.6613C17.659 12.581 17.8495 12.4482 17.999 12.2752C18.1485 12.1022 18.2522 11.8944 18.3007 11.6709C18.3491 11.4474 18.3406 11.2154 18.2761 10.996C18.2116 10.7766 18.0931 10.5769 17.9314 10.4152L9.58134 2.06603C9.32512 1.80997 8.97772 1.66609 8.61548 1.66602Z",
    stroke: "#07D3C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76357 5.42383C5.69599 5.42383 5.62993 5.44387 5.57373 5.48142C5.51754 5.51896 5.47375 5.57233 5.44789 5.63476C5.42202 5.6972 5.41526 5.7659 5.42844 5.83218C5.44162 5.89847 5.47417 5.95935 5.52196 6.00714C5.56974 6.05492 5.63063 6.08747 5.69691 6.10065C5.76319 6.11384 5.83189 6.10707 5.89433 6.08121C5.95677 6.05535 6.01013 6.01155 6.04768 5.95536C6.08522 5.89917 6.10526 5.8331 6.10526 5.76552C6.10538 5.72062 6.09663 5.67613 6.0795 5.63462C6.06237 5.59311 6.0372 5.55539 6.00545 5.52364C5.9737 5.49189 5.93598 5.46672 5.89447 5.44959C5.85296 5.43247 5.80847 5.42371 5.76357 5.42383",
    stroke: "#07D3C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_995_32388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveplanicon);
export default __webpack_public_path__ + "static/media/activeplanicon.9f9f767c7f2488f05cd633cf93d62763.svg";
export { ForwardRef as ReactComponent };